import axios from 'axios'

const DecisionPolicyFilterEnum = {
  MINIMAL_SCENARIOS_ONLY: 'minimalScenariosOnly',
  WITHOUT_SCENARIOS: 'withoutScenarios'
}

export default {
  getDecisionPolicyWithMinimalScenariosOnly(projectId, page = 0, itemsPerPage = 10) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy?filter=${DecisionPolicyFilterEnum.MINIMAL_SCENARIOS_ONLY}&page=${page}&pageSize=${itemsPerPage}`;
    return axios.get(url);
  },
  getDecisionPolicyWithoutScenarios(projectId, page = 0, itemsPerPage = 10) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy?filter=${DecisionPolicyFilterEnum.WITHOUT_SCENARIOS}&page=${page}&pageSize=${itemsPerPage}`;
    return axios.get(url);
  },
  getDecisionPolicyFull(projectId, page = 0, itemsPerPage = 10) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy?page=${page}&pageSize=${itemsPerPage}`;
    return axios.get(url);
  },
  getElementById(elementId, decisionPolicy) {
    return decisionPolicy.elements.filter(element => element.id === elementId)[0]
  },
  getOptionById(optionId, decisionPolicy) {
    return decisionPolicy.options.filter(option => option.id === optionId)[0]
  },
  mapElements(elements, decisionPolicy) {
    return elements.map(element => {
      return this.getElementById(element.id, decisionPolicy)
    })
  },
  getPreference(optionId, preferences) {
    return preferences
      .filter(preference => this.isWigo(optionId, preference))[0]
  },
  isWigo(optionId, preference) {
    return preference.wigo
      .filter(option => option.id === optionId)
      .length > 0
  },
  mapScenarios(decisionPolicy, filterElements = [], filterOptions = []) {
    let scenarios = decisionPolicy.scenarios
    if(filterElements.length > 0) {
      scenarios = scenarios
        .filter(scenario => filterElements.every( element => scenario.elements.find( filterElement => filterElement.id === element.id)))
    }
    if(filterOptions.length > 0) {
      scenarios = scenarios
        .filter(scenario => filterOptions.every(option => scenario.preferences.find(pref => pref.wigo.find(wigoOption => wigoOption.id === option.id))))
    }
    return scenarios
      .map(scenario => {
        let index = 0
        var minimalScenario = {
          scenario: {
            id: scenario.id,
            level: scenario.level,
            absoluteLevel: scenario.absoluteLevel,
            elements: this.mapElements(scenario.elements, decisionPolicy),
            createdBy: scenario.createdBy,
            createdDate: scenario.createdDate,
            lastModifiedBy: scenario.lastModifiedBy,
            lastModifiedDate: scenario.lastModifiedDate,
            noOptionLinked: false,
            index: index++
          }
        }
        let enabledAtLeatOneOption = false
        for(const option of decisionPolicy.options) {
          const preference = this.getPreference(option.id, scenario.preferences)
          const optionEnabled = preference !== undefined
          minimalScenario[option.id] = {
            value: optionEnabled,
            preferenceId: preference?.id,
            loading: false,
            color: 'success',
            index: index++
          }
          enabledAtLeatOneOption = enabledAtLeatOneOption || optionEnabled
        }
        minimalScenario.scenario.noOptionLinked = !enabledAtLeatOneOption
        return minimalScenario
      })
  },
  enableAtLeastOneScenario(optionId, decisionPolicy) {
    return decisionPolicy.scenarios
      .flatMap(scenario => scenario.preferences)
      .flatMap(preference => preference.wigo)
      .find(option => option.id === optionId) !== undefined
  },
  enableAtLeastOneScenarioForAllOptions(decisionPolicy) {
    console.log('enableAtLeastOneScenario', decisionPolicy)
    return decisionPolicy.options
      .map(option => option.id)
      .reduce((accumulator, optionId) => accumulator || this.enableAtLeastOneScenario(optionId, decisionPolicy), false)
  },
}